export default {
    path: '/2019CommercialBrand',
    name: 'CommercialBrand2019',
    component: () => import('./home.vue'),
    base: '/2019CommercialBrand/',
    meta: {
        title: '2019重庆商业（品牌）风云榜',
    },
    children: [
        {
            path: 'News',
            component: () => import('./News.vue'),
            name: '2019CommercialBrand',
            meta: {
                title: '2019重庆商业（品牌）风云榜',
            },
        },
        {
            path: 'Rules',
            component: () => import('./Rules.vue'),
            name: '2019CommercialBrand',
            meta: {
                title: '2019重庆商业（品牌）风云榜',
            },
        },
    ],
};
